module.exports = __webpack_public_path__ + "img/collectionFaceOK@2x.ad404e69.png";